import { defineComponent } from 'vue';
import props from './props';
import { MenuItem as MenuItemType } from './type';
import omit from 'lodash/omit';
import { Menu, HeadMenu, Submenu, MenuItem, Icon } from 'tdesign-vue-next';
import { navigateTo, redirectTo, getQueryParams } from '@tlbs/galaxy-sdk';

export default defineComponent({
  name: 'TlbsMenu',
  props: {
    ...props,
  },
  setup() {
    const getPageId = (path: string) => {
      if (path?.lastIndexOf('/') === -1) return '';
      const url = path?.substring(path?.lastIndexOf('/'));
      if (url.indexOf('?') !== -1) {
        return url?.substring(url?.lastIndexOf('/') + 1, url?.indexOf('?'));
      }
      return url?.substring(url?.lastIndexOf('/') + 1);
    };

    const onClickMenuItem = (options: MenuItemType) => {
      const { to, replace } = options;
      if (!to) return;
      const routerApi = replace ? redirectTo : navigateTo;
      if (typeof to === 'object') {
        routerApi({
          pageId: getPageId(to.path || ''),
          params: to.params || {},
        });
      } else if (typeof to === 'string') {
        routerApi({
          pageId: getPageId(to),
          params: getQueryParams(to),
        });
      }
    };

    const findMenuItemByPath = (
      menus: MenuItemType[],
      targetPath: string,
    ): MenuItemType | null => {
      const queue: MenuItemType[] = [];
      let targetNode: MenuItemType | null = null;
      menus.forEach(node => queue.push(node));

      while (queue.length) {
        const node = queue.shift();
        if (!node) return null;

        if (typeof node.to === 'object' && getPageId(node.to.path || '') === targetPath) {
          targetNode = node;
          break;
        } else if (typeof node.to === 'string' && getPageId(node.to) === targetPath) {
          targetNode = node;
        } else {
          node.children?.forEach(node => queue.push(node));
        }
      }

      return targetNode;
    };

    // 默认高亮当前路由对应的菜单
    const getDefaultValue = (menuData: MenuItemType[]) => {
      try {
        const url = window.location.href;
        const selectedPath = `${getPageId(url)}`;
        const targetMenu = findMenuItemByPath(menuData, selectedPath);
        console.log('targetMenu', targetMenu);
        return targetMenu?.value || '';
      } catch (error) {
        return '';
      }
    };

    const renderSubMenu = (menuData: MenuItemType[]) => menuData.map((item: MenuItemType) => {
      const { children, icon } = item;
      const slots = {
        icon: () => (icon ? <Icon name={icon}></Icon> : null),
      };
      if (children?.length) {
        return (<Submenu v-slots={slots} {...omit(item, 'children', 'icon')}>
          {renderSubMenu(children)}
        </Submenu>);
      }
      return (<MenuItem v-slots={slots} {...omit(item, 'title', 'icon', 'to')} onClick={() => onClickMenuItem(item)}>{item.title}</MenuItem>);
    });

    return {
      renderSubMenu,
      getDefaultValue,
    };
  },
  render() {
    const MenuComp = this.mode === 'vertical' ? Menu : HeadMenu;
    const { renderSubMenu, getDefaultValue } = this;
    const props = {
      ...this.$attrs,
    };
    props.defaultValue = this.defaultValue || getDefaultValue(this.menuData);
    return (
      <MenuComp {...props}>
        {renderSubMenu(this.menuData)}
      </MenuComp>
    );
  },
});
